import { MapType } from 'app/constants/schemas/Map';
import { decodeOrThrow } from 'app/utils/ioTs';
import { Record } from 'immutable';
import * as t from 'io-ts';

const CauseType = t.type({
  status: t.union([t.number, t.null, t.undefined]),
  detail: t.union([t.string, t.null, t.undefined]),
  title: t.union([t.string, t.null, t.undefined]),
  code: t.union([t.string, t.null, t.undefined]),
  meta: t.union([MapType, t.null, t.undefined]),
  exception: t.union([MapType, t.null, t.undefined]),
});

export class Cause extends Record<t.TypeOf<typeof CauseType>>({
  status: undefined,
  detail: undefined,
  title: undefined,
  code: undefined,
  meta: undefined,
  exception: undefined,
}) {}

export const CauseMarshaller = {
  deserialize: (causeData: unknown): Cause => {
    return new Cause(
      decodeOrThrow(
        CauseType,
        causeData,
        (errors) => {
          throw new Error(`Could not deserialize Cause from ${JSON.stringify(causeData)}\n${errors.join('\n')}`);
        },
      ),
    );
  },
  serialize: CauseType.encode,
};
